import keyMirror from 'keymirror';
import { createAction } from 'redux-actions';

export const types = keyMirror({
  PRODUCTS_LIST_API_HOC_RESET: null,
});

export const resetProductsListApiHOC = createAction(types.PRODUCTS_LIST_API_HOC_RESET);



// WEBPACK FOOTER //
// ./src/components/apiHOCs/ProductsListApiHOC/actions.js